// plugins/element.js
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/es/locale/lang/en'

export default function (app) {
  app.use(ElementPlus, { locale })
}
